/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { DataNotFound } from '../../../../components/DataNotFound';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';
import { Menu, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { uuid4 } from '../../../../libs';
import { toast } from 'react-toastify';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DatePickerLayout from '../../../../components/elements/DatePicker';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { printTable } from '../../../../utils/tableExportUtils';
const SDReportList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [approveStatus, setApproveStatus] = useState(-1);
  const [publishStatus, setPublishStatus] = useState(-1);
  const [applicantName, setApplicantName] = useState('');
  const [applicantMobile, setApplicantMobile] = useState('');
  const [applicantMobileName, setApplicantMobileName] = useState([]);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [loader, setLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20
  });

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const todayDate = new Date();

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const isLogin = () => {
    if (!token && !epUser) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const bodyGet = {
    EPUserID: 0,
    StatusID: approveStatus,
    PublishStatusId: publishStatus,
    ApplicantNameOrMobile: applicantName
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      'ServiceDead/GetSDReportFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      bodyGet
    )
      .then((response) => {
        setIsLoad(false);
        if (response?.data != null) {
          const uniqueResult = response?.data.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.applicantName === item.applicantName)
          );

          setApplicantMobileName(uniqueResult);
          setApiData(response?.data);
          setPageCount(response?.page);
          setNext(pageOptions.pageNo);

          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
        } else {
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
          setApiData(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // working but pending
  // const applicantNameMobileData = async () => {
  //   await postAsync(
  //     'ServiceDead/GetSDReportFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
  //     {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //         Authorization: `Bearer ${token}`,
  //       },
  //     },
  //     'multipart/form-data',
  //   )
  //     .then((response) => {
  //       if (response?.data != null) {
  //         const uniqueResult = response?.data.filter(
  //           (item, index, self) => index === self.findIndex((t) => t.applicantName === item.applicantName),
  //         );
  //         setApplicantMobileName(uniqueResult);
  //       }
  //     })
  //     .catch((error) => {
  //       toast.error(t('Something went wrong, Please try again!'));
  //     });
  // };

  const SearchFilters = {
    dateFrom: dateFrom ? moment(dateFrom).format('DD/MM/YYYY') : '',
    dateTo: dateTo ? moment(dateTo).format('DD/MM/YYYY') : '',
    publishStatusId: publishStatus,
    statusID: approveStatus,
    applicantNameOrMobile: applicantName ? applicantName : applicantMobile
  };

  const getPaginationList = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'ServiceDead/GetSDReportFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      SearchFilters
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row key={uuid4()} items={apiData}>
        <Table.Cell className="tableData">{sno}</Table.Cell>
        <Table.Cell className="tableData">{data?.applicantName}</Table.Cell>
        {/* <Table.Cell className="tableData">{data?.selectProjectType}</Table.Cell> */}
        <Table.Cell className="tableData">
          {isActive ? data?.newProjectName : data?.newProjectName}
        </Table.Cell>
        <Table.Cell className="tableData">{data?.date}</Table.Cell>
        <Table.Cell className="tableData">
          {t(
            `${data?.publishID === 1 ? 'Published' : data?.publishID === 2 ? 'Not Published' : 'Pending'}`
          )}
        </Table.Cell>
        <Table.Cell className="tableData">
          {t(
            `${data?.maApproveID === 1 ? 'Approved' : data?.maApproveID === 2 ? 'Not Approved' : 'Pending'}`
          )}
        </Table.Cell>
        <Table.Cell className="button-col">
          <Link to={`/SDReport/${data?.serviceDeadID}`}>
            <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
              {t('')}
              <VisibilityOutlinedIcon />
            </button>
          </Link>
        </Table.Cell>
      </Table.Row>
    );
  });

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync(
      'ServiceDead/GetSDReportFilterList/' + select + '/' + pageOptions.pageSize,
      bodyGet
    )
      .then((response) => {
        setPageCount(response.page);
        setApiData(response?.data);
        setNext(selected + 1);

        // apiData?.map((data) => {
        //   return setPageCount(data.page);
        // });
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const publishStatusOptions = [
    { value: 0, label: t('Pending') },
    { value: 1, label: t('Published') },
    { value: 2, label: t('Not Published') }
  ];

  const approvedStatusOptions = [
    { value: 0, label: t('Pending') },
    { value: 1, label: t('Approved') },
    { value: 2, label: t('Disapproved') }
  ];

  const handleOnExport = (e) => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Applicant Name': item.applicantName,
      'Project Name': item.newProjectName,
      Date: item.date,
      '	Publish Status':
        item?.publishID === 1
          ? t('Published')
          : item?.publishID === 2
            ? t('Not Published')
            : t('Pending'),
      // 'Item Level': item.menuLevelID,
      Status:
        item?.maApproveID === 1
          ? t('Approved')
          : item?.maApproveID === 2
            ? t('Not Approved')
            : t('Pending')
    }));

    downloadCSV(filteredData, 'SDReport');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service For Dead Manage List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Applicant Name')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Type`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Publish Status`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.applicantName || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.selectProjectType || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.newProjectName : data?.projectNameEN}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publishID === 1 ? t('Published') : data?.publishID === 2 ? t('Not Published') : t('Pending')}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.maApproveID === 1 ? t('Approved') : data?.maApproveID === 2 ? t('Not Approved') : t('Pending')}</td>
  //           </tr>
  //         `
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }

  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Applicant Name'),
      accessor: (row) => isActive ? row?.applicantName : row?.applicantName
    },
     {
      header: t('Project Type'),
      accessor: (row) => isActive ? row?.selectProjectType : row?.selectProjectType
    },   {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.newProjectName  ||  row?.projectNameEn : row?.projectNameEn ||  row?.newProjectName
    },   {
      header: t('Date'),
      accessor: (row) => isActive ? row?.date  || 'N/A' : row?.date|| 'N/A'
    },
    {
  header: t('Publish Status'),
  accessor: (row) =>
    row?.publishID === 1
      ? t('Published')
      : row?.publishID === 2
        ? t('Not Published')
        : t('Pending')
},
{
  header: t('Status'),
  accessor: (row) =>
    row?.maApproveID === 1
      ? t('Approved')
      : row?.maApproveID === 2
        ? t('Not Approved')
        : t('Pending')
}

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Service For Dead Report List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  const handleSelectApproveStatus = (e, newValue) => {
    e.preventDefault();
    setApproveStatus(newValue?.value);
  };

  const handleSelectPublishStatus = (e, newValue) => {
    e.preventDefault();
    setPublishStatus(newValue?.value);
  };

  const handleSelectApplicant = (e, newValue) => {
    e.preventDefault();
    setApplicantName(newValue?.applicantName);
    setApplicantMobile(newValue?.applicantMobile);
  };

  return (
    <div className="">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="row  justify-center py-5 mt-3">
            <div className="col-lg-11 ">
              <div className="shadow-md  rounded-md">
                <div className="card-header p-2 text-center">
                  <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                    {t('Service For Dead Report List')}
                  </h1>
                </div>
                <div className="card-body p-10">
                  <div className="row justify-center mb-3 ">
                    <div className="col-lg-6  my-2">
                      <div className="form-group flex flex-col gap-2 ">
                        <DatePickerLayout
                          label={'Date From'}
                          selectedDate={dateFrom}
                          keyValue={'from'}
                          dateFrom={dateFrom}
                          setDateFrom={setDateFrom}
                          maxDate={todayDate}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6  my-2">
                      <div className="form-group flex flex-col gap-2 ">
                        <DatePickerLayout
                          label={'Date To'}
                          selectedDate={dateTo}
                          keyValue={'to'}
                          dateTo={dateTo}
                          setDateTo={setDateTo}
                          minDate={dateFrom}
                          maxDate={todayDate}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row justify-center">
                    <div className="col-lg-6 my-2">
                      <Autocomplete
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                        id="country-customized-option-demo"
                        options={approvedStatusOptions}
                        getOptionLabel={(option) => `${option?.label} `}
                        onChange={handleSelectApproveStatus}
                        renderInput={(params) => (
                          <TextField {...params} className=" " label={t('Status')} />
                        )}
                      />
                    </div>
                    <div className="col-lg-6 my-2">
                      <Autocomplete
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                        id="country-customized-option-demo"
                        options={publishStatusOptions}
                        getOptionLabel={(option) => `${option?.label} `}
                        onChange={handleSelectPublishStatus}
                        renderInput={(params) => (
                          <TextField {...params} label={t('Publish Status')} />
                        )}
                      />
                    </div>
                    <br />
                  </div>
                  <div className="col-lg-12 my-3 ">
                    <div className="row  justify-between">
                      <div className="col-lg-6 bg-zinc-50">
                        <Autocomplete
                          options={applicantMobileName}
                          className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                          getOptionLabel={(option) =>
                            `( ${option?.applicantName})  ${option?.applicantMobile}`
                          }
                          onChange={(e, value) => handleSelectApplicant(e, value)}
                          closeText={getData}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="  border w-full border-customgreen text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              label={t('Applicant Name / Mobile')}
                            />
                          )}
                        />
                      </div>
                      <div className="form-group flex mt-4 align-bottom  justify-center px-3 ">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={(e) => handleSearch(e)}>
                          {t('Search')}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="flex justify-center lg:justify-end px-3 gap-2">
                      <div className="form-group float-right">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={(e) => handlePrint(e)}
                          disabled={!(loader === false)}>
                          {loader ? <span>Downloading...</span> : <span>{t('Print')}</span>}
                        </button>
                      </div>
                      <div className="form-group float-right">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={(e) => handleOnExport(e)}>
                          {t('Export')}
                        </button>
                      </div>
                    </div>
                  </div>{' '}
                </div>
              </div>
              <div className=" pt-9">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="shadow-md  rounded-md overflow-x-auto">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                        <Table.Row>
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">
                            {t('Applicant Name')}
                          </Table.HeaderCell>
                          {/* <Table.HeaderCell className="text-white">{t('Project Type')}</Table.HeaderCell> */}
                          <Table.HeaderCell className="text-white">
                            {t('Project Name')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">
                            {t('Publish Status')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>{displayRecords}</Table.Body>
                    </Table>
                  </div>
                )}
                {datanotfound && <DataNotFound />}

                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu floated="right" pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SDReportList;
